!function() {
  "use strict";
  customElements.get("ajax-modal") || customElements.define("ajax-modal", class extends HTMLElement {
    button=this.querySelector("a");
    url=this.button?.href;
    view=this.dataset.view;
    parent=this;
    id=!1;
    constructor() {
      super();
    }
    loadStart() {
      this.parent?.classList.add("opacity-50", "cursor-wait");
    }
    loadEnd() {
      this.parent?.classList.remove("opacity-50", "cursor-wait"), setTimeout((() => {
        if (this.id) {
          const video = document.querySelector(`#${this.id} video`);
          if (video) video.readyState && !video.paused && video.play(); else {
            const image = document.querySelector(`#${this.id} .vw-cmp__in-video-card--preview img, #${this.id} img.needsclick`);
            image && image.click();
          }
        }
      }), 500);
    }
    load() {
      if (this.loadStart(), this.id) {
        const details = document.getElementById(this.id);
        if (details) return setTimeout((() => details.open = !0)), void this.loadEnd();
      }
      let url = new URL(this.url);
      this.view && url.searchParams.set("view", this.view), fetch(url).then((response => {
        if (response.ok) return response.text();
        throw new Error(response.message);
      })).then((text => {
        if (!(text.length > 0)) throw new Error("Error: Empty response");
        {
          const html = (new DOMParser).parseFromString(text, "text/html"), details = html.body.firstElementChild.querySelector("details");
          details && (this.id = `AjaxModal-${(new Date).getTime()}`, details.id = this.id), 
          document.body.append(html.body.firstElementChild);
        }
      })).catch((error => {
        console.warn(error), location.href = this.url;
      })).finally((() => {
        this.loadEnd();
      }));
    }
    connectedCallback() {
      this.url && this.button.addEventListener("click", (event => {
        event.preventDefault(), this.load();
      }));
    }
  });
}();